/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.
*/


(function() {
  // Add custom code below this line


  /* ======================================
     Rewards Ladder — dynamic updater
     Live-updates bar fill, markers, headline,
     and the unlocked summary line on every
     cart change. Mirrors the Liquid logic so
     no page reload is needed.
     ====================================== */

  function rlFormatMoney(cents) {
    return window.theme.formatMoney(cents, theme.moneyFormat).replace('.00', '');
  }

  function updateRewardsLadder(subtotalCents) {
    const ladder = document.querySelector('[data-rewards-ladder]');
    if (!ladder) return;

    const maxThreshold = parseInt(ladder.getAttribute('data-rl-max'), 10) * 100;
    const tiers = [
      { num: 1, cents: parseInt(ladder.getAttribute('data-rl-t1'), 10) * 100,
        enabled: ladder.getAttribute('data-rl-t1-enabled') === 'true',
        label: ladder.getAttribute('data-rl-t1-label') || '' },
      { num: 2, cents: parseInt(ladder.getAttribute('data-rl-t2'), 10) * 100,
        enabled: ladder.getAttribute('data-rl-t2-enabled') === 'true',
        label: ladder.getAttribute('data-rl-t2-label') || '' },
      { num: 3, cents: parseInt(ladder.getAttribute('data-rl-t3'), 10) * 100,
        enabled: ladder.getAttribute('data-rl-t3-enabled') === 'true',
        label: ladder.getAttribute('data-rl-t3-label') || '' }
    ];

    // Bar fill
    const fillEl = ladder.querySelector('[data-rl-fill]');
    if (fillEl) {
      const percent = Math.min(100, (subtotalCents / maxThreshold) * 100);
      fillEl.style.width = percent + '%';
    }

    // Marker states
    tiers.forEach(function (tier) {
      if (!tier.enabled) return;
      const unlocked = subtotalCents >= tier.cents;
      const marker = ladder.querySelector('[data-rl-marker="' + tier.num + '"]');
      if (marker) marker.classList.toggle('is-unlocked', unlocked);
    });

    // Next target + any-unlocked
    let nextTier = null;
    for (let i = 0; i < tiers.length; i++) {
      if (tiers[i].enabled && subtotalCents < tiers[i].cents) {
        nextTier = tiers[i];
        break;
      }
    }
    const anyUnlocked = tiers.some(function (t) {
      return t.enabled && subtotalCents >= t.cents;
    });

    // Headline
    const headlineEl = ladder.querySelector('[data-rl-headline]');
    if (headlineEl) {
      let state, html;
      if (nextTier === null) {
        state = 'final';
        html = ladder.getAttribute('data-rl-headline-final') || '';
      } else {
        const tpl = anyUnlocked
          ? (ladder.getAttribute('data-rl-headline-upgrade') || '')
          : (ladder.getAttribute('data-rl-headline-first') || '');
        state = anyUnlocked ? 'upgrade' : 'first';
        const amountSpan = '<span data-rl-remaining>' +
          rlFormatMoney(nextTier.cents - subtotalCents) + '</span>';
        html = tpl.replace('||amount||', amountSpan)
                  .replace('||reward||', nextTier.label);
      }
      headlineEl.innerHTML = html;
      ladder.setAttribute('data-rl-state', state);
    }

    // Unlocked line (Tier 2 hidden once Tier 3 active)
    const unlockedWrap = ladder.querySelector('[data-rl-unlocked-wrap]');
    const unlockedListEl = ladder.querySelector('[data-rl-unlocked-list]');
    if (unlockedWrap && unlockedListEl) {
      const t1 = tiers[0], t2 = tiers[1], t3 = tiers[2];
      const t1On = t1.enabled && subtotalCents >= t1.cents;
      const t2On = t2.enabled && subtotalCents >= t2.cents;
      const t3On = t3.enabled && subtotalCents >= t3.cents;

      const parts = [];
      if (t1On) parts.push(t1.label);
      if (t2On && !t3On) parts.push(t2.label);
      if (t3On) parts.push(t3.label);

      unlockedListEl.textContent = parts.join(' + ');
      unlockedWrap.classList.toggle('is-hidden', !anyUnlocked);
    }
  }

  function fetchAndUpdateRewardsLadder() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateRewardsLadder(cart.items_subtotal_price);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.cartUpdate, function (data) {
        // Only trust the payload if it carries a usable number;
        // otherwise fetch the authoritative value from /cart.js.
        const raw = data && data.cartData ? data.cartData.items_subtotal_price : undefined;
        const subtotal = typeof raw === 'number' && isFinite(raw) ? raw : null;
        if (subtotal !== null) {
          updateRewardsLadder(subtotal);
        } else {
          fetchAndUpdateRewardsLadder();
        }
      });
    }
    document.addEventListener('theme:cart:change', function () {
      fetchAndUpdateRewardsLadder();
    });
  });


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();